import React, { useState,useRef, useEffect } from "react";
import crop from "../assets/icons/icon-crop.svg";
import down from "../assets/icons/icon-down.svg";
import shirt from "../assets/icons/icon-shirt.svg";
import line from "../assets/icons/icon-line.svg";
import hearticon from "../assets/icons/icon-hearticon.svg";
import { handleDownloadSVG } from "../utils/fabricHelper";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setActiveTab } from "../Store/reducers/activeTabSlice";
import { setPendingDownload } from "../Store/reducers/fabricCanvasSlice";
import { handleDownload } from "../utils/fabricHelper";
import { enableDownload,disableDownload } from "../Store/reducers/downloadSlice";
import { showPopup } from "../Store/reducers/popUpSlice";

const Navbar = () => {
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const dispatch = useDispatch();

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [colorPickerVisible, setColorPickerVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState();
  const canvas = useSelector((state) => state.canvas.app);
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const canvasesState = useSelector((state) => state.canvasesstate.canvases);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user = useSelector((state) => state.user.data);
   const testsiteSvg=  useSelector((state) => state.svgDetails);
   const disabled = useSelector(state => state.download.disabled);
   console.log("testsiteSvg",testsiteSvg)
  const productId = queryParams.get("product_id");
  const handleColorChange = (event) => {
    const color = event.target.value;
    if (activeTab === "editSVG") {
      const currentBackgroundColor = fabricCanvas.backgroundColor || "#ffffff";
      setSelectedColor(currentBackgroundColor);
    }
    if (fabricCanvas && activeTab === "editSVG") {
      fabricCanvas.setBackgroundColor(
        color,
        fabricCanvas.renderAll.bind(fabricCanvas)
      );
    }
  };

  const handleDropdownToggle = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleDownloadWithTabSwitch = async (targetDownloadName) => {
    if (activeTab !== targetDownloadName) {
      dispatch(setActiveTab(targetDownloadName));
    }
    
      canvasesState[`${targetDownloadName}CanvasState`]?.currentState;
       let  savedState =   canvasesState[`${targetDownloadName}CanvasState`]?.currentState;
    if (!fabricCanvas || (activeTab !== targetDownloadName && (targetDownloadName !== "editSVG") || !savedState )) {
      console.log("inside fabcanvs download");
      dispatch(setPendingDownload(true));
    } else {
      handleDownload(targetDownloadName, fabricCanvas, canvasesState, () => {
        dispatch(setPendingDownload(false));
        console.log("after fabcanvs download");
      }); 
    }
  };

  const disableDownloadMockup = activeTab === "editSVG";

  const hasRunOnce = useRef(false);
  
  useEffect(() => {
    if (hasRunOnce.current || activeTab === "editSVG"  ) return;
  
    if (!user || !testsiteSvg?.svgDetails) return;
  
    const isPremiumSVG = testsiteSvg.svgDetails.data?.is_premium === true;
    const userRole = user?.data?.user_role || "guest";
    const isFreeUser = userRole !== "premium";               
  
    if (isPremiumSVG && isFreeUser ) {
         dispatch(
      showPopup("Please upgrade to premium, this is a premium Svg.")
                               );
      dispatch(disableDownload()); 
    } else {
      dispatch(enableDownload());
    }
  
    hasRunOnce.current = true;
  }, [testsiteSvg, user]);

  


 

  return (
    <div>
      <div className="flex items-center justify-between bg-[#000000] text-white px-4 py-2">
        <div className="flex items-center space-x-2">
          <h1 className="text-[37px] font-montserrat leading-[45.1px] font-semibold">
            Studio
          </h1>
          <img src={line} alt="line Icon" className="w-37px" />
          <img src={hearticon} alt="hearticon Icon" className="w-80px h-35px" />
        </div>

        <div className="space-x-4 flex items-center mr-5">
          <div className="flex flex-row">
            <img src={crop} alt="Crop Icon" className="w-20px h-20px" />
            <button
              className="px-3 py-1 rounded text-[16px]"
              onClick={handleDropdownToggle}
            >
              Canvas Size & Background
            </button>
          </div>

          <div
             className={`flex flex-row ${
              disabled || disableDownloadMockup ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
            }`}
            onClick={() => {
          
              if (!disabled || !disableDownloadMockup)    handleDownloadWithTabSwitch("editMockup");
            
            }}

          >
            <img src={shirt} alt="Shirt Icon" className="w-20px h-20px" />
            <button className="px-3 py-1 rounded text-[16px]">
              Download Mockup
            </button>
          </div>

          <div
            className={`flex flex-row ${
              disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
            }`}
          
          >
            <img src={down} alt="Down Icon" className="w-20px h-20px" />
            <button
              onClick={() => {
                disabled 
                handleDownloadWithTabSwitch("editSVG");
                
              }}
              className="px-3 py-1 rounded text-[16px]"
            >
              Download SVG
            </button>
          </div>
        </div>
      </div>

      {dropdownVisible && (
        <div className="absolute top-[50px] right-[387px] w-[226px] bg-black text-white shadow-md rounded py-2 z-50">
          <div className="flex flex-col space-y-1 divide-y divide-gray-500 w-full font-semibold text-[16px]">
            <button className="py-2 text-left pl-10">Canvas Size</button>
            <button
              className="py-2 text-left pl-10"
              onClick={() => setColorPickerVisible(!colorPickerVisible)}
            >
              Canvas Background
            </button>
          </div>
          {colorPickerVisible && (
            <div className="absolute top-[60px] right-[7px]">
              <input
                type="color"
                value={selectedColor}
                onChange={handleColorChange}
                className="w-7 h-7"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
